module.exports = __webpack_public_path__ + "static/media/CADEGettingStarted.4b716c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/CADEGettingStarted.png
// module id = 1125
// module chunks = 0